import { render, staticRenderFns } from "./Bienvenido.vue?vue&type=template&id=76604370&scoped=true"
import script from "./Bienvenido.vue?vue&type=script&lang=js"
export * from "./Bienvenido.vue?vue&type=script&lang=js"
import style0 from "./Bienvenido.vue?vue&type=style&index=0&id=76604370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76604370",
  null
  
)

export default component.exports